<template>
    <form-field v-bind="fieldProps">
        <textarea-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])"></textarea-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            placeholder: { type: String, default: undefined },
            type: { type: String, default: 'text' },
        },
    }
</script>
